import React from 'react';
import type { FC } from 'react';
import { SiteAuthProvider } from '@wix/cli-auth';
import { useProjectModel } from '../../model.js';
import { EnvSet } from './EnvSet.js';

export const EnvSetCommand: FC<{
  variable: { key: string; value: string };
}> = ({ variable }) => {
  const {
    model: {
      config: { siteId },
    },
  } = useProjectModel();

  return (
    <SiteAuthProvider siteId={siteId}>
      <EnvSet variable={variable} />
    </SiteAuthProvider>
  );
};
